import React from 'react';
import { X, ExternalLink } from 'lucide-react';
import { Dialog, DialogContent, DialogTitle, DialogDescription } from '../ui/dialog';
import { resolveImageUrl } from '../../lib/imageCache';

// Enlarged swatch view for the public fabric browser
export const SwatchZoomModal = ({ color, open, onOpenChange }) => {
  if (!color) return null;
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-3xl p-0 overflow-hidden bg-neutral-950 border-neutral-800 text-white" data-testid="swatch-zoom-modal">
        <div className="flex items-center justify-between px-5 py-3 border-b border-neutral-800">
          <div className="min-w-0">
            <DialogTitle className="font-serif text-lg truncate" data-testid="swatch-zoom-name">{color.name}</DialogTitle>
            <DialogDescription className="text-xs text-neutral-400 font-mono truncate">
              {[color.code, color.collection_name, color.material_name].filter(Boolean).join(' · ')}
            </DialogDescription>
          </div>
          <button onClick={() => onOpenChange(false)} className="p-2 rounded-full hover:bg-neutral-800" aria-label="Close" data-testid="swatch-zoom-close"><X className="w-5 h-5" /></button>
        </div>
        <div className="bg-neutral-900 flex items-center justify-center" style={{ minHeight: '60vh' }}>
          {color.image_url
            ? <img src={resolveImageUrl(color.image_url, 1024)} alt={color.name} className="max-h-[70vh] w-auto max-w-full object-contain" data-testid="swatch-zoom-image" />
            : <div className="w-64 h-64 rounded-xl" style={{ backgroundColor: color.hex_color || '#ccc' }} />}
        </div>
        {color.webshop_url && (
          <div className="px-5 py-3 border-t border-neutral-800 text-xs">
            <a href={color.webshop_url} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 text-amber-400 hover:text-amber-300">
              <ExternalLink className="w-3 h-3" /> Product details on brand website
            </a>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default SwatchZoomModal;
